import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { snackbarStyles } from '../../Styles/snackbarStyles';
import { inject, observer } from 'mobx-react';
import Snackbar from '@material-ui/core/Snackbar';
import { ReactSVG } from 'react-svg';
import Images from '../../Theme/Images';
import DeleteDialog from './DeleteDialog';
import Tooltip from '@material-ui/core/Tooltip';

@inject('documentStore', 'userStore', 'dashboardStore')
@observer
class FileActionSnackbar extends Component {
    state = { openDeleteDialog: false }

    assignDocuments = () => {
        this.props.userStore.openDialog()
        this.props.dashboardStore.openFileAssign()
    }

    exportDocs = () => {
        this.props.dashboardStore.exportDocuments(this.props.filter);
        this.props.dashboardStore.closeActionSnackbar();
    }

    onDelete = () => {
        this.setState({ openDeleteDialog: true })
    }

    deleteMultipleDocs = () => {
        this.props.dashboardStore.deleteMultipleDocs(this.props.filter);
        this.props.dashboardStore.closeActionSnackbar();
    }

    cancelDelete = () => {
        this.setState({ openDeleteDialog: false })
    }

    closeActions = () => {
        this.props.dashboardStore.closeActionSnackbar();
        this.props.dashboardStore.resetSelectedDocuments()
    }

    onDownload = () => {
        this.props.dashboardStore.downloadBulkDocs(this.props.filter)
    }

    renderActions = () => {
        const { selectedDocs } = this.props.dashboardStore;
        const { classes, activeTab } = this.props;
        var counts = {};
        selectedDocs.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });
        return (
            <div className={classes.container}>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginTop: '1vh' }}>{counts[true]} {counts[true] === 1 ? 'File' : 'Files'} selected</div>
                    {activeTab !== 'drafts' ? <ReactSVG src={Images.navExported} onClick={(e) => this.exportDocs()} beforeInjection={svg => { svg.classList.add(classes.svg) }} /> : null}
                    {activeTab === 'drafts' ? <ReactSVG src={Images.assignUser} onClick={(e) => this.assignDocuments()} beforeInjection={svg => { svg.classList.add(classes.svg) }} />  : null}
                   <ReactSVG src={Images.delete} onClick={(e) => this.onDelete()} beforeInjection={svg => { svg.classList.add(classes.svg) }} /> 
                   <ReactSVG src={Images.download} onClick={(e) => this.onDownload()} beforeInjection={svg => { svg.classList.add(classes.svg) }} /> 

                </div>

                <ReactSVG src={Images.closeSelection} onClick={(e) => this.closeActions()} style={{ marginTop: '1VH' }} beforeInjection={svg => { svg.classList.add(classes.svg) }} />
                <DeleteDialog open={this.state.openDeleteDialog} cancelDelete={this.cancelDelete} delete={this.deleteMultipleDocs}></DeleteDialog>
            </div>
        )
    }

    render() {
        const { classes
         } = this.props;
        const { openActionSnackbar } = this.props.dashboardStore;
        return (
            <Snackbar
                ContentProps={{
                    classes: {
                        root: classes.snackbar
                    }
                }}
                message={this.renderActions()} open={openActionSnackbar}  >
            </Snackbar>
        )
    }
}

FileActionSnackbar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(snackbarStyles)(FileActionSnackbar);
